var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.jsonList),function(i,index){return _c('div',{key:index,staticClass:"item"},[_vm._v(_vm._s(index)+". "+_vm._s(i))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }